import React, {Component} from 'react';
import {Icon} from 'antd';
import PropsType from 'prop-types';
import utils from "../utils";
// position: fixed;
// bottom: 14px;
// right: 14px;
// border: 1px solid #e8e8e8;
class QRCode extends Component {
    constructor(props) {
        super(props);
        const size = props.size, text = props.text || [], other = text.length > 0 ? (text.length * 21) : 0;
        this.state = {
            loading: true,
            id: props.id || "qrcode-canvas",
            width: size || 200,
            height: size ? (size + other) : 200,
        };
    }

    async componentDidMount() {
        this._isMounted = true;
        const {id} = this.state;
        const {src, text, size} = this.props;
        const canvas = document.getElementById(id);
        const ctx = canvas.getContext('2d');
        const qrImg = await utils.imageLoad(ctx, src, size - 20, size - 20);
        if (qrImg) ctx.drawImage(qrImg, 10, 10, size - 20, size - 20);
        if (text && text.length > 0) {
            ctx.font = "bold 12px 微软雅黑";
            ctx.textAlign="center";
            let top = size+6;
            for (let i = 0; i < text.length; i++) {
                ctx.fillText(text[i] || '', size / 2, top);     //姓名
                top += 21;
            }
        }
        if (this._isMounted) {
            this.setState({loading: false});
        }

    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const {id, width, height, loading} = this.state;
        return (
            <div style={{width, height, border: "1px solid #e8e8e8", textAlign: "center", background: "#fff", opacity: .8, borderRadius: 6}}>
                <canvas id={id} width={width} height={height} hidden={loading}/>
                <Icon type="loading" style={{marginTop: "50%", fontSize: 28, color: "#ccc"}}hidden={!loading}/>
            </div>
        );
    }
}

QRCode
    .propsTypes = {
    src: PropsType.string.isRequired,//二维码路径
    text: PropsType.array,//二维码文字数组
    size: PropsType.number,//二维码大小
    id: PropsType.string,//canvas-id
}
export default QRCode;



// WEBPACK FOOTER //
// ./src/components/QRCode.jsx